<!-- =========================================================================================
  File Name: ResourceCreate.vue
  Description: Resource Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="frequencyUpdatePermission" id="page-user-edit">
		<vx-card>
			<frequency-edit-tab v-if="frequency !== null" :dataFrequency="frequency" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import FrequencyEditTab from "./FrequencyEditTab.vue";

export default {
	components: {
		NotPermission,
		FrequencyEditTab,
	},
	data() {
		return {
			frequency: null,
		};
	},
	created() {
		this.getFrequencyById(parseInt(this.$route.params.id));
	},
	computed: {
		frequencyUpdatePermission() {
			return this.$store.getters.checkPermission("FREQUENCY_U");
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		getFrequencyById(frequencyId) {
			this.openLoading();
			this.$store
				.dispatch("frequency/frequencyFilter", {id: [frequencyId]})
				.then((res) => {
					this.frequency = res.records[0];
					this.closeLoading();
					return res.records;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
